export function initContactForm(translations) {
    let formData = {
        name: '',
        email: '',
        message: '',
        agree: false
    };

    let errors = { name: false, email: false, message: false, agree: false };
    let touched = { name: false, email: false, message: false, agree: false };
    let isLoading = false;
    let status = null;

    const form = document.getElementById('contactForm');
    const emailInput = document.getElementById('email');
    const nameInput = document.getElementById('name');
    const messageInput = document.getElementById('message');
    const agreeInput = document.getElementById('agree');
    const submitBtn = document.getElementById('submitBtn');
    const popupOverlay = document.getElementById('popupOverlay');
    const closePopup = document.getElementById('closePopup');
    const popupIcon = document.getElementById('popupIcon');
    const popupImg = document.getElementById('popupImg');
    const popupHeader = document.getElementById('popupHeader');
    const popupMessage = document.getElementById('popupMessage');

    if (!form) return;

    if (emailInput) emailInput.addEventListener('input', handleInputChange);
    if (nameInput) nameInput.addEventListener('input', handleInputChange);
    if (messageInput) messageInput.addEventListener('input', handleInputChange);
    if (emailInput) emailInput.addEventListener('blur', handleBlur);
    if (nameInput) nameInput.addEventListener('blur', handleBlur);
    if (messageInput) messageInput.addEventListener('blur', handleBlur);
    if (agreeInput) agreeInput.addEventListener('change', handleCheckboxChange);
    if (form) form.addEventListener('submit', handleSubmit);
    if (closePopup) closePopup.addEventListener('click', handleClosePopup);

    checkFormValidity();

    function handleInputChange(e) {
        const { name, value } = e.target;
        if (name === 'name') {
            const cleanedValue = value.replace(/[^\p{L}\s]/gu, '');
            formData.name = cleanedValue.trimStart();
            e.target.value = formData.name;
        } else {
            formData[name] = value;
        }
        validateField(name);
        checkFormValidity();
    }

    function handleCheckboxChange(e) {
        formData.agree = e.target.checked;
        validateField('agree');
        checkFormValidity();
    }

    function handleBlur(e) {
        const { name } = e.target;
        if (name === 'agree') return;
        touched[name] = true;
        validateField(name);
        updateFieldUI(name);
    }

    function validateField(field) {
        let error = false;
        switch (field) {
            case 'name':
                error = !/^[\p{Letter}\s]*$/u.test(formData.name) ||
                    formData.name.trim() === '' ||
                    formData.name.length < 2 ||
                    formData.name.length > 50;
                break;
            case 'email':
                error = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
                break;
            case 'message':
                error = formData.message.trim() === '' || formData.message.length > 1000;
                break;
            case 'agree':
                error = !formData.agree;
                break;
        }
        errors[field] = error;
        if (touched[field]) {
            updateFieldUI(field);
        }
    }

    function updateFieldUI(field) {
        const input = document.getElementById(field);
        const label = document.getElementById(field + 'Label');
        const errorEl = document.getElementById(field + 'Error');
        const isError = errors[field] && touched[field];

        if (input) input.classList.toggle('error', isError);
        if (label) {
            label.classList.toggle('error-label', isError);
            label.classList.toggle('hidden', isError);
        }
        if (errorEl) {
            errorEl.style.display = isError ? 'block' : 'none';
        }
    }

    function validateForm() {
        ['name', 'email', 'message', 'agree'].forEach(field => {
            touched[field] = true;
            validateField(field);
        });
        return !Object.values(errors).some(e => e);
    }

    async function handleSubmit(e) {
        e.preventDefault();
        if (!validateForm()) return;

        isLoading = true;
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = translations.sendingMessage || 'Sending...';
        }
        status = {
            type: 'loading',
            header: translations.headerLoading || 'Sending…',
            message: translations.sendingMessage || 'Sending message…'
        };
        showPopup();

        try {
            const response = await fetch('/api/send-form', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
                },
                body: JSON.stringify(formData)
            });
            const data = await response.json();

            if (data.status !== 'success') {
                throw new Error(translations.errorMessage || 'Error');
            }

            status = {
                type: 'success',
                header: translations.headerSuccess || 'Message sent',
                message: translations.successMessage || 'Thank you! Your message has been sent.'
            };
            resetForm();
        } catch (error) {
            console.error('Submit error:', error);
            status = {
                type: 'error',
                header: translations.headerError || 'Error',
                message: translations.errorMessage || 'Something went wrong.'
            };
        } finally {
            isLoading = false;
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = translations.submit || 'Send message';
            }
            showPopup();
        }
    }

    function resetForm() {
        formData = { name: '', email: '', message: '', agree: false };
        errors = { name: false, email: false, message: false, agree: false };
        touched = { name: false, email: false, message: false, agree: false };
        if (nameInput) {
            nameInput.value = '';
            nameInput.classList.remove('error');
        }
        if (emailInput) {
            emailInput.value = '';
            emailInput.classList.remove('error');
        }
        if (messageInput) {
            messageInput.value = '';
            messageInput.classList.remove('error');
        }
        if (agreeInput) {
            agreeInput.checked = false;
            agreeInput.classList.remove('error');
        }
        ['name', 'email', 'message', 'agree'].forEach(field => updateFieldUI(field));
        checkFormValidity();
    }

    function showPopup() {
        if (popupOverlay) popupOverlay.style.display = 'flex';
        if (closePopup) closePopup.style.display = status.type !== 'loading' ? 'block' : 'none';
        if (popupHeader) popupHeader.textContent = status.header;
        if (popupMessage) popupMessage.textContent = status.message;
        const iconSrc = {
            success: '/img/contact-form/success.svg',
            error: '/img/contact-form/error.svg',
            loading: '/img/contact-form/loader.svg'
        }[status.type] || '/img/contact-form/error.svg';
        if (popupImg) popupImg.src = iconSrc;
        if (popupIcon && status.type === 'loading') {
            popupIcon.classList.add('icon-loading');
        } else if (popupIcon) {
            popupIcon.classList.remove('icon-loading');
        }
    }

    function handleClosePopup() {
        if (popupOverlay) popupOverlay.style.display = 'none';
        status = null;
    }

    function checkFormValidity() {
        ['name', 'email', 'message', 'agree'].forEach(field => validateField(field));
        const isValid = !Object.values(errors).some(e => e);
        if (submitBtn) submitBtn.disabled = !isValid || isLoading;
    }
}